var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayout1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_581_17904)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 0.625C1.46447 0.625 0.625 1.46447 0.625 2.5V9.375C0.625 10.4105 1.46447 11.25 2.5 11.25H7.5C8.53553 11.25 9.375 10.4105 9.375 9.375V2.5C9.375 1.46447 8.53553 0.625 7.5 0.625H2.5Z",
    fill: "#D42124"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 19.375C11.4645 19.375 10.625 18.5355 10.625 17.5V10.625C10.625 9.58947 11.4645 8.75 12.5 8.75H17.5C18.5355 8.75 19.375 9.58947 19.375 10.625V17.5C19.375 18.5355 18.5355 19.375 17.5 19.375H12.5Z",
    fill: "#D42124"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625 14.375C0.625 13.3395 1.46447 12.5 2.5 12.5H7.5C8.53553 12.5 9.375 13.3395 9.375 14.375V17.5C9.375 18.5355 8.53553 19.375 7.5 19.375H2.5C1.46447 19.375 0.625 18.5355 0.625 17.5V14.375Z",
    fill: "#D42124"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 7.5C11.4645 7.5 10.625 6.66053 10.625 5.625V2.5C10.625 1.46447 11.4645 0.625 12.5 0.625H17.5C18.5355 0.625 19.375 1.46447 19.375 2.5V5.625C19.375 6.66053 18.5355 7.5 17.5 7.5H12.5Z",
    fill: "#D42124"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_581_17904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout1);
export default __webpack_public_path__ + "static/media/layout-1.7cd0832762064534b70f797c16a6d9fe.svg";
export { ForwardRef as ReactComponent };